<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <span class="title_head">Search</span>
            <span v-if="sale_view === true"></span>
          </div>
          <div class="card-body">
            <div class="row">
              <div
                class="col-sm-12 alert alert-success"
                v-if="haserror.message != ''"
                style="text-align: center;"
              >
                {{ haserror.message }}
              </div>
            </div>
            <b-row>
              <b-col sm="3" v-if="is_admin === true">
                <b-form-group>
                  <label for="Company List"> Company List </label><br />
                  <model-list-select
                    :list="companylist"
                    option-value="company_id"
                    option-text="company_name"
                    v-model="selectcompany"
                    placeholder="Search Company Name"
                    @searchchange="searchcompany($event)"
                    @input="onSelectCompany($event)"
                    style="
                      -webkit-text-fill-color: rgb(83, 108, 121) !important;
                      height: 30px !important;
                      border: 1px solid rgb(194, 207, 214);
                      min-height: 30px;
                      border-radius: 1px;
                      padding-top: 6px;
                    "
                    class="product-drop"
                  ></model-list-select>
                  <small class="form-text text-muted" v-show="show"
                    ><strong style="color: red;"
                      >Please select company</strong
                    ></small
                  >
                </b-form-group>
              </b-col>
              <b-col sm="3">
                <b-form-group>
                  <label for="name">Customer Name : </label>
                  <model-list-select
                    :list="customerlist"
                    option-value="customer_id"
                    option-text="cust_cmp_name"
                    v-model="selectcustomer"
                    placeholder="Search Customer"
                    @searchchange="searchcustomer($event)"
                    style="
                      -webkit-text-fill-color: rgb(83, 108, 121) !important;
                      height: 30px !important;
                      border: 1px solid rgb(194, 207, 214);
                      min-height: 30px;
                      border-radius: 1px;
                      padding-top: 6px;
                    "
                    class="product-drop"
                  ></model-list-select>
                  <!-- <b-form-input
                    type="text"
                    v-model="srch_custname"
                    placeholder="Enter Customer Name"
                    autocomplete="off"
                  >
                  </b-form-input> -->
                  <!-- <input
                    type="text"
                    class="form-control"
                    v-model="search.custname"
                    id="custname"
                    name="custname"
                    autocomplete="off"
                    placeholder="Enter Customer Name"
                  /> -->
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group>
                  <label for="name">Select Shop </label><br />
                  <!-- <span style="display: flex;"> -->
                  <model-list-select
                    :list="shopname"
                    option-value="est_shop_id"
                    option-text="est_shop_name"
                    v-model="selectshop"
                    placeholder="Select Shop"
                  ></model-list-select>
                  <!-- </span> -->
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <button
                  type="button"
                  style="margin-top: 24px; margin-left: 16%;"
                  class="btn btn-pill btn-primary serach_bttn"
                  @click="searchlist"
                >
                  <i class="fa fa-search"></i>&nbsp;Search
                </button>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <div slot="header">
              <div class="row">
                <div class="col-sm-10">
                  <i style="color: #20a8d8;"></i> List of Customers Whose
                  Payment is Pending
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                &nbsp;&nbsp;
                <div class="col-sm-1">
                  <button
                    type="button"
                    class="btn btn-sm btn-primary label_bttn"
                    @click.prevent="exportData()"
                  >
                    <i class=""></i> Export Data
                  </button>
                </div>
              </div>
            </div>
            <!-- <span class="title_head"
              >List of Customers Whose Payment is Pending
            </span>
            <span
              >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

              <button
                type="button"
                class="btn btn-sm btn-primary label_bttn"
                @click.prevent="exportData()"
              >
                <i class="fa fa-plus"></i> Export Data
              </button>
            </span> -->
          </div>
          <div class="card-body">
            <vue-good-table
              :columns="columns"
              :rows="rows"
              mode="remote"
              ref="my-table"
              @on-page-change="onPageChange"
              @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
              :totalRows="totalRecords"
              :pagination-options="{ enabled: true, perPage: 10 }"
              styleClass="vgt-table striped bordered table-sm condensed"
              ><template slot="table-row" slot-scope="props">
                <span v-if="props.column.field === 'action'">
                  <i
                    class="fa fa-eye"
                    @click.prevent="view_detail(props.row)"
                  ></i>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      title="Summary of Supplier Balance Amount "
      no-close-on-esc
      no-close-on-backdrop
      size="lg"
      hide-footer
      class="modal-warning"
      v-model="warningModal"
      @ok="warningModal = true"
      ok-variant="warning"
    >
      <b-collapse id="collapse1" visible>
        <vue-good-table
          :columns="columns1"
          :rows="rows1"
          mode="remote"
          ref="my-table1"
          @on-page-change="onPageChange1"
          @on-sort-change="onSortChange1"
          @on-column-filter="onColumnFilter1"
          @on-per-page-change="onPerPageChange1"
          :totalRows="totalRecords1"
          :pagination-options="{ enabled: true, perPage: 10 }"
          styleClass="vgt-table striped bordered table-sm condensed"
        >
          <!-- <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field == 'tax_inclusive'">
                  <div v-if="props.row.tax_inclusive == true">Inclusive</div><div v-else>Exclusive</div>
              </span>
              <span v-else-if="props.column.field == 'gst_total'">
                {{ (parseFloat(props.row.cgst_amt)+parseFloat(props.row.sgst_amt)+parseFloat(props.row.igst_amt)).toFixed(2) }}
              </span>
              <span v-else>
                {{props.formattedRow[props.column.field]}}
              </span>
            </template>                   -->
        </vue-good-table>
      </b-collapse>
    </b-modal>
    <Spinner v-if="loading"></Spinner>
  </div>
</template>

<script>
import Spinner from "../../../spinner.vue";
import { VueEditor } from "vue2-editor";
import DatePicker from "vue2-datepicker";
export default {
  components: {
    "date-picker": DatePicker,
    Spinner,
  },
  data() {
    return {
      min_admin: false,
      show: false,
      companylist: [],
      selectcompany: null,
      customerlist: [],
      selectcustomer: null,
      selectshop: null,
      slfirst: false,
      shpfirst: false,
      srchfirst: false,
      rfrst_time: false,
      shopname: [],
      selectshop: null,
      rows: [],
      rows1: [],
      loading: false,
      totalRecords: 0,
      totalRecords1: 0,
      // srch_custname:'',
      warningModal: false,
      // customername: [],
      // selectedcustomer: null,
      haserror: {
        message: "",
      },
      serverParams: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10,
      },
      serverParams1: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10,
      },
      columns: [
        {
          label: "Customer Name",
          field: "cust_cmp_name",
          width: "20% !important",
          thClass: "text-center",
        },
        {
          label: "Shop",
          field: "est_shop_name",
          width: "20% !important",
          thClass: "text-center",
        },
        {
          label: "Total Amount",
          field: "total_amt_pay",
          width: "20% !important",
          formatFn: this.formatFn,
          thClass: "text-center",
        },
        {
          label: "Balance Amount",
          field: "total_amt_pendingpay",
          width: "20% !important",
          formatFn: this.formatFn,
          thClass: "text-center",
        },
        {
          label: "Action",
          field: "action",
          width: "20% !important",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
      columns1: [
        {
          label: "Sales Id",
          field: "sales_id",
          width: "10% !important",
          thClass: "text-center",
        },
        {
          label: "Shop Name",
          field: "est_shop_name",
          width: "20% !important",
          thClass: "text-center",
        },
        {
          label: "Total Amount",
          field: "total_amt_pay",
          width: "20% !important",
          formatFn: this.formatFn,
          thClass: "text-center",
        },
        {
          label: "Balance Amount",
          field: "total_amt_pendingpay",
          width: "20% !important",
          formatFn: this.formatFn,
          thClass: "text-center",
        },
        {
          label: "Date",
          field: "lastupdated_dt",
          type: "date",
          dateInputFormat: "YYYY-MM-DDThh:mm:ss",
          dateOutputFormat: "Do MMM YYYY",
          tdClass: "text-left",
          thClass: "text-center",
          width: "30% !important",
        },
        // ,
        // {
        //   label: "Action",
        //   field: "action",
        //   width: "20% !important",
        //   thClass: "text-center",
        //   tdClass: "text-center"
        // }
      ],
    };
  },
  computed: {
    sale_view: function () {
      if (this.$store.getters.get_is_admin !== true) {
        if (this.$store.getters.get_sale_view === true) {
          this.shopuser("comp");
          Promise.all([this.searchshops("comp")]).then((ret_val) => {
            this.sales("comp");
            return true;
          });
        } else {
          return false;
        }
      } else {
        this.min_admin = true;
      }
    },
    sale_rights: function () {
      return this.$store.getters.get_sale_rights;
    },
    is_admin: function () {
      return this.$store.getters.get_is_admin;
    },
  },

  methods: {
    searchcompany(searchText) {
      var _this = this;
      this.$http
        .get(
          "/api/companies?filter[where][company_name][ilike]=%" +
            searchText +
            "%"
        )
        .then(function (response) {
          // console.log(response)
          _this.companylist = response.data;
          // this.show = false
          // this.searchshops()
        })
        .catch(function (error) {});
    },

    onSelectCompany(selectedcompany) {
      this.show = false;
      this.searchshops();
    },

    searchcustomer(searchText) {
      if (this.min_admin === true && this.selectcompany === null) {
        this.show = true;
        return;
      }
      var data = "?filter[where][cust_cmp_name][ilike]=%" + searchText + "%";
      if (this.selectcompany !== null) {
        data =
          data +
          "&filter[where][company_id]=" +
          this.selectcompany.company_id +
          "&filter[where][regcity]=" +
          this.selectcompany.regcity_code;
      }
      var _this = this;
      this.$http
        .get("/api/customers" + data)
        .then(function (response) {
          _this.customerlist = response.data;
        })
        .catch(function (error) {});
    },

    // nameAndnumber(item) {
    //   return `${item.cust_cmp_name} - ${item.cust_cmp_phone}`;
    // },

    shopuser(val) {
      if (val === "comp") {
        if (this.shpfirst === false) {
          this.shpfirst = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http
        .get("/api/shopusers")
        .then(function (response) {})
        .catch(function (error) {
          if (error.response.status === 401) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
          if (
            error.response.data.error.message ===
            "Cannot read property 'cmpname' of null"
          ) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
        });
    },

    formatFn(value) {
      return parseFloat(value).toFixed(2);
    },
    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.loadItems();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },
        page: 1,
      });
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },

    updateParams1(newProps) {
      this.serverParams1 = Object.assign({}, this.serverParams, newProps);
    },
    onPageChange1(params) {
      this.updateParams1({ page: params.currentPage });
      this.view_detail(this.temprow);
    },

    onPerPageChange1(params) {
      this.updateParams1({ perPage: params.currentPerPage, page: 1 });
      this.view_detail(this.temprow);
    },

    onSortChange1(params) {
      this.updateParams1({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },
        page: 1,
      });
      this.view_detail(this.temprow);
    },

    onColumnFilter1(params) {
      this.updateParams1(params);
      this.view_detail(this.temprow);
    },

    // load items is what brings back the rows from server
    loadItems() {
      // console.log('loadItems')
      var _this = this;
      let filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      this.rows = [];
      var data = "";

      if (
        this.selectcustomer !== null &&
        this.selectcustomer.customer_id !== undefined
      ) {
        data =
          data +
          "&filter[where][customer_id]=" +
          this.selectcustomer.customer_id;
      }
      if (this.selectcompany !== null) {
        if (this.selectcompany.company_id !== undefined)
          data =
            data +
            "&filter[where][company_id]=" +
            this.selectcompany.company_id +
            "&filter[where][regcity]=" +
            this.selectcompany.regcity_code;
      }
      if (this.selectshop.est_shop_id !== "0") {
        data =
          data + "&filter[where][est_shop_id]=" + this.selectshop.est_shop_id;
      }

      var api =
        "/api/saledetails/getPendingPayment?params=" +
        JSON.stringify(filteParam) +
        data;
      
      this.$http
        .get(
          "/api/saledetails/getPendingPayment?params=" +
            JSON.stringify(filteParam) +
            data
        )
        .then(function (response) {
          _this.totalRecords = response.data[0].totalRecords;
          response.data.shift();
          if (response.data !== undefined) _this.rows = response.data;
          // console.log(response)
        })
        .catch(function (er) {
          console.log(er);
        });
    },

    async sales(val) {
      if (val === "comp") {
        if (this.slfirst === false) {
          this.slfirst = true;
        } else {
          return;
        }
      }
      this.loadItems();
      return Promise.resolve(true);
    },

    view_detail(row) {
      // console.log(row)
      this.rows1.length = 0;
      let filteParam = {};
      filteParam.page = this.serverParams1.page;
      filteParam.perPage = this.serverParams1.perPage;
      filteParam.sort = this.serverParams1.sort;
      this.warningModal = true;
      var _this = this;
      // this.temprow = row;
      // // var data =[]
      var data = "&filter[where][cust_id]=" + row.customer_id;
      if (this.selectcompany !== null) {
        data =
          data +
          "&filter[where][company_id]=" +
          this.selectcompany.company_id +
          "&filter[where][regcity]=" +
          this.selectcompany.regcity_code;
      }
      if (row.est_shop_id !== "0") {
        data = data + "&filter[where][shop_id]=" + row.est_shop_id;
      }

      this.$http
        .get(
          "/api/saledetails/pendingBalance?params=" +
            JSON.stringify(filteParam) +
            data
        )
        .then(function (response) {
          if (response.data !== undefined) {
            _this.totalRecords1 = response.data[0].totalRecords;
            response.data.shift();
            _this.rows1 = response.data;
            // console.log(_this.rows1)
          }
        });
    },

    async searchshops(val) {
      if (val === "comp") {
        if (this.srchfirst === false) {
          this.srchfirst = true;
        } else {
          return;
        }
      }
      var _this = this;
      var response = null;
      if (this.selectcompany !== null) {
        response = await this.$http.get(
          "/api/shopusers/getShop?filter[where][company_id]=" +
            this.selectcompany.company_id +
            "&filter[where][user_id]=" +
            this.selectcompany.cmp_email
        );
      } else {
        response = await this.$http.get("/api/shopusers/getShop");
      }
      var all_shop = {
        est_shop_name: "All Shops",
        est_shop_id: "0",
      };
      _this.shopname = response.data;
      _this.shopname.push(all_shop);
      // var len = this.shopname.length - 1
      _this.selectshop = all_shop;
      if (_this.shopname.length > 0) {
        return Promise.resolve(true);
      }
    },

    searchlist() {
      this.loadItems();
    },

    exportData() {
      var _this = this;
      this.loading = true;
      let filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      // this.rows = [];
      var data = "";
      if (
        this.selectcustomer !== null &&
        this.selectcustomer.customer_id !== undefined
      ) {
        data =
          data +
          "&filter[where][customer_id]=" +
          this.selectcustomer.customer_id;
      }
      if (this.selectcompany !== null) {
        if (this.selectcompany.company_id !== undefined)
          data =
            data +
            "&filter[where][company_id]=" +
            this.selectcompany.company_id +
            "&filter[where][regcity]=" +
            this.selectcompany.regcity_code;
      }
      if (this.selectshop.est_shop_id !== "0") {
        data =
          data + "&filter[where][est_shop_id]=" + this.selectshop.est_shop_id;
      }
      this.$http
        .get(
          "/api/saledetails/getsalesbalancereport?params=" +
            JSON.stringify(filteParam) +
            data
        )
        .then(function (response) {
          _this.loading = false;
          var __this = _this;
          var access_token = localStorage.getItem("authUser");
          var url1 =
            _this.baseURL2 +
            "/api/containers/csv/download/" +
            response.data +
            "?access_token=" +
            access_token;
          if (response.data !== null || response.data !== "") {
            _this
              .$http({
                url: url1,
                method: "GET",
                responseType: "blob",
              })
              .then((res) => {
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const link = document.createElement("a");
                link.setAttribute("download", response.data);
                link.href = url1;
                document.body.appendChild(link);
                link.click();
              })
              .catch(function (error) {
                console.log(error);
                __this.haserror.message =
                  "Something Went Wrong, Please try again later";
              });
          } else {
            __this.haserror.message =
              "Something Went Wrong, Please try again later";
          }
        })
        .catch(function (error) {
          _this.loading = false;
          console.log(error);
        });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/reports/sales/pending_pay_list.vue